import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  MasterAgreement,
  MontlyRateCalculationResponse
} from '../../../store/_declarations/target';
import { useAppSelector } from '../../../store/hooks';
import { allInOneFormatter } from '../../../utils/formatters';
import Font from '../../atoms/Font';
import Spinner from '../../atoms/Spinner';
import { HeaderProduct } from './styles';

type TitleProps = {
  isLoading: boolean;
  item: MasterAgreement;
};
type ItemDetails = {
  price?: string;
  productName?: string;
};
const Title: FC<TitleProps> = ({ isLoading, item }) => {
  const { montlyRateCalculation } = useAppSelector(
    (state) => state.financialCalculator
  );
  const { consumerPayload } = useAppSelector((state) => state.app);

  const { t } = useTranslation();

  const [itemDetails, setItemDetails] = useState<ItemDetails>({
    price: '-',
    productName: ''
  });

  useEffect(() => {
    const newItemDetails: ItemDetails = {};
    if (
      montlyRateCalculation?.[item.masterAgreement] &&
      typeof montlyRateCalculation?.[item.masterAgreement] !== 'string'
    ) {
      const price = montlyRateCalculation?.[
        item.masterAgreement
      ] as MontlyRateCalculationResponse;
      newItemDetails.price = allInOneFormatter(
        consumerPayload,
        price.regularPayment.amountExclTax,
        t('Pricing')
      );
    }
    if (item) {
      newItemDetails.productName = item.masterAgreementDesc;
    }

    setItemDetails(newItemDetails);
  }, [montlyRateCalculation, item]);

  return (
    <HeaderProduct>
      <Font
        customConfiguration={{ color: 'brand1', textAlign: 'right' }}
        data-testid="monthlyPrice"
        variant="heading4"
      >
        {itemDetails.productName}
      </Font>
      <Font
        customConfiguration={{ color: 'brand1', textAlign: 'right' }}
        data-testid="monthlyPrice"
        variant="heading4"
      >
        {isLoading ? (
          <Spinner size={16} testid="product-cart-spinner" />
        ) : (
          itemDetails.price
        )}
      </Font>
    </HeaderProduct>
  );
};

export default Title;
